<script lang="ts">
  import type { StoryblokStory } from "storyblok-generate-ts";
  import type {
    PostStoryblok,
    SocialLinkStoryblok,
    AnchorLinkWithCssClassStoryblok,
    PageStoryblok,
  } from "$types/components";
  import { getContext } from "svelte";
  import { storyblokEditable } from "@storyblok/svelte";
  import Footer from "$lib/views/Footer.svelte";
  import PostHero from "$lib/molecules/newsroom/post/PostHero.svelte";
  import PostContent from "$lib/molecules/newsroom/post/PostContent.svelte";
  import PostCTA from "$lib/molecules/newsroom/post/PostCTA.svelte";
  import NewsroomList from "./NewsroomList.svelte";

  export let blok: PostStoryblok;
  const footerNavigation = getContext(
    "footerNavigation",
  ) as StoryblokStory<PageStoryblok>[];
  const socials = getContext("socials") as SocialLinkStoryblok[];
  const footerBottomLinks = getContext(
    "footerBottomLinks",
  ) as AnchorLinkWithCssClassStoryblok[];
</script>

<div class={`post`} use:storyblokEditable={blok}>
  <PostHero {blok} />

  <section class="post-content-max-width mx-auto padding-top-100 px-[20px]">
    <PostContent {blok} />
  </section>

  {#if blok.cta && blok.cta.length > 0}
    <PostCTA {blok} />
  {/if}

  {#if blok.newsroomList && blok.newsroomList.length > 0}
    <div class="px-[20px] max-w-[1288px] mx-auto padding-top-25">
      <NewsroomList blok={blok.newsroomList[0]} related={true} grid={false} />
    </div>
  {/if}
  <Footer
    theme={blok.page_main_color}
    categories={blok.footer_categories}
    {socials}
    {footerBottomLinks}
    navigation={footerNavigation}
  />
</div>

<style lang="scss">
  .post {
    padding-top: 0;
    position: relative;
    background: rgb(var(--color-light-grey));
    z-index: 5;
  }

  :global(.post-content-max-width) {
    @apply max-w-[800px];
  }
</style>
